module.exports = __webpack_public_path__ + "static/media/cartoon_grade_sj_des.63c5a52d.png";